import React from 'react';
import { makeStyles } from '@mui/styles';
import { Select, MenuItem, InputLabel, FormControl, Typography, Box } from '@mui/material';
import { ReactComponent as DropDownIcon } from "../../assets/icons/icon-angle-down.svg"

const useStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: "10%",
    width: "100",
  }
}))

export default function Limit({handleReportLimit, limitValue, index}) {
  const classes = useStyles();
    return (
        <Box sx={{marginBottom: {xs: 0, sm: '8px'}}}>
            <FormControl variant="outlined" className={classes.formControl + " width-auto m-0"}   >
              <Typography className="report-form-label text-plain" variant="subtitle1" >Limit Upto</Typography>
              <Select
                className="report_form_ui_input_select pl-0"
                value={limitValue || ''}
                onChange={(e) => handleReportLimit(e, index)}
                size='small'
                IconComponent={DropDownIcon}
              >
                <MenuItem className="menu-item"  key={10} value={10}>10</MenuItem>
                <MenuItem className="menu-item"  key={20} value={20}>20</MenuItem>
                <MenuItem className="menu-item"  key={50} value={50}>50</MenuItem>
                <MenuItem className="menu-item"  key={100} value={100}>100</MenuItem>
                <MenuItem className="menu-item"  key={200} value={200}>200</MenuItem>
                <MenuItem className="menu-item"  key={500} value={500}>500</MenuItem>
                <MenuItem className="menu-item"  key={1000} value={1000}>1000</MenuItem>      
              </Select>
          </FormControl>
        </Box>
    )
}
